import {styled} from '@mui/system';
import {Card} from '@mui/material';

export const MuiTechnicianSettingsCard = styled(Card)(({theme}) => ({
	marginTop: theme.spacing(0),
	paddingLeft: theme.spacing(2),
}));
